import { useEffect, memo, useState } from "react";
import { Grid2, Typography, InputAdornment } from "@mui/material";
import { Image } from "mui-image";
import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSnackbar } from "../utils/index.js";
import Spinner from "../components/Spinner.js";
import Form from "../components/Form.js";
import logo from "../assets/images/logo-white-first.png";
import { invitedSignUp } from "../api/index.js";
import useAuthenticationStyles from "../components/styles/Authentication.js";

const InvitedSignUp = () => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const token = urlParams.get("token");
	const email = decodeURIComponent(urlParams.get("email"));
	const { state } = useLocation();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const classes = useAuthenticationStyles();
	const { error } = useSnackbar();
	const navigate = useNavigate();

	const [showPassword, setShowPassword] = useState(false);

	const handleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const submitHandler = async (values) => {
		setIsSubmitting(true);

		console.log('VALUES', values.username, values.fullName, values.password, email, token)
		try {
			const { success: successCode, message } = await invitedSignUp(values.username, values.fullName, values.password, email, token);

			if (successCode) {
				navigate("/");
			} else {
				error(message);
			}
		} catch (err) {
			error(err);
		}

		setIsSubmitting(false);
	};

	useEffect(() => {
		try {
			sessionStorage.setItem("redirectTo", JSON.stringify(state?.from || { pathname: "/home" }));
		} catch { /** */ }
	}, [state]);

	const formContent = [
		{
			customType: "input",
			id: "username",
			type: "text",
			placeholder: "Όνομα χρήστη* (π.χ johndoe)",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton disabled>
							<AccountCircle />
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "fullName",
			type: "text",
			placeholder: "Ονοματεπώνυμο* (π.χ John Doe)",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton disabled>
							<AccountCircle />
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "password",
			type: showPassword ? "text" : "password",
			placeholder: "Κωδικός χρήστη*",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton
							aria-label="toggle password visibility"
							tabIndex={-1}
							onClick={handleShowPassword}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "button",
			id: "submit",
			type: "submit",
			text: "ΕΓΓΡΑΦΗ",
		},
	];

	return (
		<>
			<Spinner open={isSubmitting} />
			<Grid2 container className={classes.root}>
				<Grid2
					item
					container
					direction="column"
					justifyContent="center"
					alignItems="center"
					sm={5}
					xs={12}
					mt={'-10rem'}
					sx={{ "> .MuiGrid-item": { p: 1 } }}
				>
					<Grid2 item mb={3}>
						<Image src={logo} alt="Logo" className={classes.logo} />
					</Grid2>
					<Grid2 item mt={2}>
						<Typography
							variant="h7"
							fontWeight="bold"
							className={classes.subtitle}
						>
							{"Ολοκληρώστε την εγγραφή σας συμπληρώνοντας τη φόρμα παρακάτω:"}
						</Typography>
					</Grid2>
					<Grid2
						item
						container
						direction="column"
						justifyContent="center"
						alignItems="center"
						sx={{ width: "100%" }}
					>
						<Form
							content={formContent}
							validationSchema="signUpSchema"
							onSubmit={submitHandler}
							sx={{ width: "600px" }}
						/>
					</Grid2>
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(InvitedSignUp);
